module.exports = __webpack_public_path__ + "img/UKC-1968.f03a12b8.png";